module.exports = __webpack_public_path__ + "img/v6.7e6447b2.png";